export default __webpack_public_path__ + "static/media/shiba-inu.bc66e864.png";